'use client';

import { useEffect, useState } from 'react';

import { useTranslation } from '@/lib/i18n/i18n.client';

import {
  getMessageForDownServices,
  ReducedInstatusComponent,
} from '@/components/atoms/Instatus/utils';
import { TooltipProps } from '@/components/atoms/Tooltip/Tooltip';
import { apiCall } from '@/utils/fetch';

import { ServiceStatusComponent } from './ServiceStatus';

export type ServiceStatusProps = {
  size?: 'sm' | 'md';
  /** optional prop used to calculate text truncation */
  containerMaxWidth?: number;
  classNames?: {
    text?: string;
    button?: string;
    icon?: {
      inner?: string;
      outer?: string;
    };
    tooltip?: TooltipProps['classNames'];
  };
};

export const ServiceStatus = ({ classNames, size }: ServiceStatusProps) => {
  const [components, setComponents] = useState<
    ReducedInstatusComponent[] | null
  >([]);

  const { texts } = useTranslation();
  const { message, status } = getMessageForDownServices(
    components || [],
    texts
  );
  useEffect(() => {
    if (components?.length) return;

    apiCall<ReducedInstatusComponent[]>({
      url: `/next-api/service-status`,
      method: 'GET',
    })
      .then((r) => {
        if (Array.isArray(r?.data)) {
          setComponents(r?.data);
        } else {
          throw new Error('Components are not an array:' + JSON.stringify(r));
        }
      })
      .catch((err) => {
        console.error(err);

        setComponents(null);
      });
  }, [components?.length]);

  if (!components?.length) return null;

  return (
    <ServiceStatusComponent
      message={message}
      classNames={classNames}
      size={size}
      status={status}
    />
  );
};
